import { useQuery } from "react-query";
import { RelatorioDemonstrativoReceitaDespesaPdfResponse, FiltroRelatorioReceitaDespesa } from "../typings";
import { AxiosError } from "axios";
import http from "infra/http";

export function useRelatorioDemonstrativoReceitaDespesaPdf(query?: FiltroRelatorioReceitaDespesa) {
  return useQuery<RelatorioDemonstrativoReceitaDespesaPdfResponse, AxiosError>(
    ['/v1/relatorios/financeiro/demonstrativo-receita-despesa/pdf', query],
    async () => {
      const {data} = await http.get('/v1/relatorios/financeiro/demonstrativo-receita-despesa/pdf', {
        params: query
      })

      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useRelatorioDemonstrativoReceitaDespesaPdf;
